export default __webpack_public_path__ + "static/media/roadmap.202c44ef.png";